import { v4 as uuid } from 'uuid';
import { answer as answerEndpoints } from '../../api/endpoints';
export const ANSWER_GET = 'ANSWER_GET';
export const ANWSER_GET_SUCCESS = 'ANSWER_GET_SUCCESS';

// "answerOf" says which object the answer belongs to ('task', 'taskLine' or 'certification').
// More details in the header of ContributeAnwserPage.jsx.
// See src/api/<version>/endpoints.js to view the parser and endpoints that follows from it.
// "answerOf" is set by the route that mounts the page, see App.jsx.
export const getAnswer = (answerOf, params) => ({
  type: ANSWER_GET,
  fetch: { ...answerEndpoints.get(answerOf, params), auth: true },
  meta: { requestId: uuid() },
});
